interface SplitBarProps {
  holderBps: number;
  lpTimeBps: number;
  burnBps: number;
  compact?: boolean;
}

export function SplitBar({ holderBps, lpTimeBps, burnBps, compact }: SplitBarProps) {
  const total = holderBps + lpTimeBps + burnBps || 10000;
  const pct = (n: number) => `${(n / total) * 100}%`;

  return (
    <div
      className="w-full"
      role="img"
      aria-label={`Split ${holderBps / 100}/${lpTimeBps / 100}/${burnBps / 100}`}
    >
      <div
        className={`flex ${compact ? "h-2" : "h-3"} overflow-hidden rounded-chip border border-white/10`}
      >
        <div
          className="bg-wing transition-all duration-200"
          style={{ width: pct(holderBps) }}
          title={`持币分 LP ${holderBps / 100}%`}
        />
        <div
          className="bg-bnb transition-all duration-200"
          style={{ width: pct(lpTimeBps) }}
          title={`LP 时间分 BNB ${lpTimeBps / 100}%`}
        />
        <div
          className="bg-ember transition-all duration-200"
          style={{ width: pct(burnBps) }}
          title={`回购销毁 ${burnBps / 100}%`}
        />
      </div>
    </div>
  );
}
